import React from 'react';
import AxeptioWrapper from 'src/components/Common/AxeptioWrapper';
import classNames from 'classnames';

interface VideoProps {
  /** CSS class name */
  className?: string;
  /** Link to the video. */
  link: string;
  /** Title of the Video. */
  title: string;
}

/** Embeds Video. */
const Video = ({ className, link, title }: VideoProps) => (
  <div className={classNames(className, 'ce ce-video')}>
    <div className="video-wrapper">
      <AxeptioWrapper slug="Youtube">
        <iframe
          src={link}
          frameBorder="0"
          title={title}
          allowFullScreen
          allow="encrypted-media"
        />
      </AxeptioWrapper>
    </div>
  </div>
);

Video.defaultProps = {
  className: null,
};

export default Video;
